export default __webpack_public_path__ + "static/028-8cc9f2210f946114da505d12d5df79a8.png";